module.exports = __webpack_public_path__ + "static/media/rentready_pink.79f3193a.png";